import type { TableOfContentsCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useCreateTableOfContentsFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TableOfContentsCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function TableOfContentsCreationPanel({ fragment, onDelete }: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateTableOfContentsFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("TableOfContentsCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
